import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1a84675c from 'nuxt_plugin_plugin_1a84675c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_workbox_02b4dd0e from 'nuxt_plugin_workbox_02b4dd0e' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_00c193be from 'nuxt_plugin_metaplugin_00c193be' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_0446db95 from 'nuxt_plugin_iconplugin_0446db95' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_cookieinjectorclient_62783eca from 'nuxt_plugin_cookieinjectorclient_62783eca' // Source: ../plugins/cookie-injector.client.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"A tool that helps you compare, differentiate, analyze, visualize text online | Diff Viewer","script":[{"src":"https:\u002F\u002Fpagead2.googlesyndication.com\u002Fpagead\u002Fjs\u002Fadsbygoogle.js?client=ca-pub-4467877923505914","crossorigin":"anonymous"}],"meta":[{"charset":"utf-8"},{"name":"keywords","content":"compare text, difference, diff view, diff viewer, diff checker, hamming distance, difference, data privacy, differentiate, differentiator, text differentiator"},{"name":"color-scheme","content":"dark light"},{"name":"viewport","content":"width=750px; initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"theme-color","content":"#2563EB"},{"name":"og:url","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app"},{"name":"og:image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002Fbrand-430x495.png"},{"name":"twitter:title","property":"og:url","content":"A privacy focused tool and\u002For utility that allows you to compare\u002Fanalyze\u002Fcontrast\u002Fdifferentiate\u002Fvisualize\u002Fanalyze pieces of texts"},{"name":"og:title","property":"og:url","content":"A privacy focused tool and\u002For utility that allows you to compare\u002Fanalyze\u002Fcontrast\u002Fdifferentiate\u002Fvisualize\u002Fanalyze pieces of texts"},{"name":"og:type","property":"og:url","content":"website"},{"name":"description","property":"og:url","content":"A privacy focused tool and\u002For utility that allows you to compare\u002Fanalyze\u002Fcontrast\u002Fdifferentiate\u002Fvisualize\u002Fanalyze pieces of texts"},{"name":"og:description","property":"og:url","content":"A privacy focused tool and\u002For utility that allows you to compare\u002Fanalyze\u002Fcontrast\u002Fdifferentiate\u002Fvisualize\u002Fanalyze pieces of texts"},{"name":"twitter:description","property":"og:url","content":"A privacy focused tool and\u002For utility that allows you to compare\u002Fanalyze\u002Fcontrast\u002Fdifferentiate\u002Fvisualize\u002Fanalyze pieces of texts"},{"name":"twitter:card","property":"og:url","content":"summary"},{"name":"twitter:creator","property":"og:url","content":"@technikhil314"},{"name":"og:image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002F128x128.png"},{"name":"og:image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002Fbrand-192x192.png"},{"name":"og:image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002Fbrand-200x200.png"},{"name":"og:image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002Fbrand-512x512.png"},{"name":"og:image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002Fbrand-800x800.png"},{"name":"image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002Fbrand-1200x600.png"},{"name":"og:image:alt","property":"og:url","content":"A privacy focused tool and\u002For utility that allows you to compare\u002Fanalyze\u002Fcontrast\u002Fdifferentiate\u002Fvisualize\u002Fanalyze pieces of texts"},{"name":"twitter:image","property":"og:url","content":"https:\u002F\u002Fdiffviewer.vercel.app\u002F128x128.png"},{"name":"google-adsense-account","content":"ca-pub-4467877923505914"}],"link":[{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"sitemap","type":"application\u002Fxml","title":"Sitemap","href":"\u002Fsitemap.xml"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Open+Sans&display=swap","rel":"stylesheet"},{"rel":"icon","media":"(prefers-color-scheme: light)","type":"image\u002Fx-icon","href":"\u002Fdark-favicon.ico"},{"rel":"shortcut icon","media":"(prefers-color-scheme: light)","href":"\u002Fdark-favicon.ico","type":"image\u002Fx-icon"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","href":"\u002Fdark-apple-touch-icon.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"57x57","href":"\u002Fdark-apple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"72x72","href":"\u002Fdark-apple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"76x76","href":"\u002Fdark-apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"114x114","href":"\u002Fdark-apple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"120x120","href":"\u002Fdark-apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"144x144","href":"\u002Fdark-apple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"152x152","href":"\u002Fdark-apple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: light)","sizes":"180x180","href":"\u002Fdark-apple-touch-icon-180x180.png"},{"rel":"icon","media":"(prefers-color-scheme: dark)","type":"image\u002Fx-icon","href":"\u002Flight-favicon.ico"},{"rel":"shortcut icon","media":"(prefers-color-scheme: dark)","href":"\u002Flight-favicon.ico","type":"image\u002Fx-icon"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","href":"\u002Flight-apple-touch-icon.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"57x57","href":"\u002Flight-apple-touch-icon-57x57.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"72x72","href":"\u002Flight-apple-touch-icon-72x72.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"76x76","href":"\u002Flight-apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"114x114","href":"\u002Flight-apple-touch-icon-114x114.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"120x120","href":"\u002Flight-apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"144x144","href":"\u002Flight-apple-touch-icon-144x144.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"152x152","href":"\u002Flight-apple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","media":"(prefers-color-scheme: dark)","sizes":"180x180","href":"\u002Flight-apple-touch-icon-180x180.png"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1a84675c === 'function') {
    await nuxt_plugin_plugin_1a84675c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_02b4dd0e === 'function') {
    await nuxt_plugin_workbox_02b4dd0e(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_00c193be === 'function') {
    await nuxt_plugin_metaplugin_00c193be(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_0446db95 === 'function') {
    await nuxt_plugin_iconplugin_0446db95(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookieinjectorclient_62783eca === 'function') {
    await nuxt_plugin_cookieinjectorclient_62783eca(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
